import React from 'react'
import styles from './Navbar.module.css'
import logo from '../../assets/images/logo.jpg'
import { Link } from 'react-router-dom'


function Navbar() {
  const scrollToFooter = () => {
    const footer = document.getElementById('footer');
    footer.scrollIntoView({ behavior: 'smooth' });
   
  };
  return (
    <div className= {styles.appNavbar}>
      <div className={styles.appNavbarLogo}>
      <img src={logo} alt='logo' className={styles.logo}/>
     
        </div>

        {/* <div className={styles.name}>
          <h1>
            -CRICWAY-
          </h1>
        </div> */}
      <ul className={styles.appNavbarLinks}>
        
          <li className={styles.navLinks}><Link to={'/'}>Home</Link></li>
          <li className={styles.navLinks}onClick={scrollToFooter}><Link>About</Link></li>
          <li className={styles.navLinks}><Link to={'/fixtures'}>Fixtures</Link></li>
          <li className={styles.navLinks}>< Link to={'/newsDetails'}>News</Link></li>
          <li className={styles.navLinks}><Link to={'/contact-us'}>Contact Us</Link></li> 
          
        </ul>  
      {/* <div className={styles.appNavbarSignIn}>
        <button className={styles.appNavbarSignInButton}>
          SignIn
        </button>
      </div> */}
    </div>
  )
}

export default Navbar